/* eslint-disable complexity */
// Copyright (c) 2016 Deere & Company

import * as fetchService from '../../../shared/services/fetch';
import {buildSearchParams} from '../../dealer-search/service/search-params';
import {getIsPinTransferEnabled} from '../services/get-is-pin-transfer-enabled-aor';
import {handleError} from '../../../shared/services/error-handlers';

const basePath = '/api';

export async function getDetails(pin, suppressErrors = false) {

    const endPoint = `${basePath}/products/${pin}`;

    const options = {
        endpointId: 'products'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return suppressErrors ? response.json() : handleError(response);

    }

}

export async function getDivision(isSapUp = true) {

    const endPoint = isSapUp ? `${basePath}/constants?id=DIVISION` : `${basePath}/dealers/constants?id=DIVISION`;

    const options = {
        endpointId: 'products'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getProductClaims(pin) {

    const endPoint = `${basePath}/products/${pin}/claims`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getProductWarranties(pin, currentMachineHours) {

    const endPoint = currentMachineHours ? `${basePath}/products/${pin}/warranties?currentMachineHours=${currentMachineHours}` :
        `${basePath}/products/${pin}/warranties`;

    const options = {
        endpointId: 'warranties'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getSearchResults(query, searchBy) {

    const endPoint = `${basePath}/products/search?by=${searchBy}&q=${encodeURIComponent(query)}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getTransferDetails(transferID) {

    const endPoint = `${basePath}/transfers/${transferID}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getProductMaintenancePlans(pin) {

    const endPoint = `${basePath}/products/${pin}/maintenance-plans`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function updateTransfer(updatedTransfer) {

    const isPinTransferEnabled = getIsPinTransferEnabled('pin-transfer-aor');

    const endPoint = isPinTransferEnabled ? `${basePath}/pin/transfers/${updatedTransfer.id}` : `${basePath}/transfers/${updatedTransfer.id}`;

    const options = {
        body: JSON.stringify(updatedTransfer),
        endpointId: isPinTransferEnabled ? 'pin-transfer-aor' : 'transfers',
        method: 'PUT'
    };

    try {

        return await fetchService.fetch(endPoint, options);

    } catch (response) {

        return handleError(response);

    }

}

export async function createNewTransfer(newTransfer) {

    const endPoint = `${basePath}/transfers`;

    const options = {
        body: JSON.stringify(newTransfer),
        endpointId: 'transfers',
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getRegistrationResults(registrationPayload) {

    const endPoint = registrationPayload.export === 'EXCEL' ?
        `${basePath}/registrations/collection?export=EXCEL` :
        `${basePath}/registrations/collection`;

    const fetchOptions = {
        body: JSON.stringify(registrationPayload),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, fetchOptions);

        return registrationPayload.export === 'EXCEL' ?
            response :
            response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getTransferResults(transferPayload) {

    const endPointPinTransfer = transferPayload.export === 'EXCEL' ?
        `${basePath}/transfers/collection?export=EXCEL` :
        `${basePath}/pin/transfers/collection`;

    const endPointTransfer = transferPayload.export === 'EXCEL' ?
        `${basePath}/transfers/collection?export=EXCEL` :
        `${basePath}/transfers/collection`;

    const isPinTransferEnabled = getIsPinTransferEnabled('pin-transfer-aor');

    const endPoint = isPinTransferEnabled ? endPointPinTransfer : endPointTransfer;

    const fetchOptions = {
        body: JSON.stringify(transferPayload),
        endpointId: isPinTransferEnabled ? 'pin-transfer-aor' : 'transfers',
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, fetchOptions);

        return transferPayload.export === 'EXCEL' ?
            response :
            response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getTransferRejectedReason(userLocale) {

    const endPoint = `${basePath}/reject/${userLocale}`;

    const options = {
        endpointId: 'pin-transfer-aor'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getPIPDetails(pin) {

    const endPoint = `${basePath}/products/${pin}/pips`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getOptionCodes(pin) {

    const endPoint = `${basePath}/products/${pin}/options`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getComponentDetails(pin) {

    const endPoint = `${basePath}/products/${pin}/components`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getImplementsDetails(pin) {

    const endPoint = `${basePath}/products/${pin}/implements`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getIncentiveProgramsDetails(incentivePaylod) {

    const endPoint = `${basePath}/products/${incentivePaylod.pin}/machine-programs`;

    const options = {
        body: JSON.stringify(incentivePaylod),
        cloudPreferred: true,
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getRegistrationHistory(pin) {

    const endPoint = `${basePath}/products/${pin}/registrations`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getUndoRegistrationHistory(registration) {

    const endPoint = `${basePath}/products/registrations`;

    const options = {
        body: JSON.stringify(registration),
        method: 'PUT'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function saveBaseMachineImplements(baseMachineComponents, pin) {

    const endPoint = `${basePath}/products/${pin}/implements`;

    const options = {
        body: JSON.stringify(baseMachineComponents),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}
export async function createNewRegistration(newRegistration) {

    const endPoint = `${basePath}/registrations`;

    const options = {
        body: JSON.stringify(newRegistration),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function updateEditRegistration(registrationID, updatedRegistration) {

    const endPoint = `${basePath}/registrations/${registrationID}`;

    const options = {
        body: JSON.stringify(updatedRegistration),
        method: 'PUT'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getStatesInCountry(query) {

    const endPoint = `${basePath}/constants?id=STATE&filter1Key=COUNTRY&filter1Value=${encodeURIComponent(query)}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getDealer(account) {

    const endPoint = `${basePath}/dealers/${account}`;

    const options = {
        endpointId: 'products'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getDealerResults(params) {

    const searchParams = buildSearchParams(params).join('&');

    const endPoint = `${basePath}/dealers?${searchParams}`;

    const options = {
        endpointId: 'products'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function deleteRegistration(registrationID) {

    const endPoint = `${basePath}/registrations/${encodeURIComponent(registrationID)}`;

    const options = {
        method: 'DELETE'
    };

    try {

        return await fetchService.fetch(endPoint, options);

    } catch (response) {

        return handleError(response);

    }

}

export async function getRegistrationTypes() {

    const endPoint = `${basePath}/constants?id=STATUS_INDICATOR`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getCountries() {

    const endPoint = `${basePath}/constants?id=COUNTRY`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getPurchaseTypes(filterKey, filterOperator, filterValue) {

    const endPoint = `${basePath}/constants?id=PURCHASER_TYPE&filter1Key=${filterKey}&filter1Operator=${filterOperator}&filter1Value=${filterValue}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getPrimaryProductStatuses() {

    const endPoint = `${basePath}/constants?id=MACHINE_STATUS`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getFacetsPrimaryProductStatuses() {

    const endPoint = `${basePath}/constants?id=PRTSEARCH_STATUS&filter1Key=PRIORITY&filter1Value=900&filter1Operator=le`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getFacetsSecondaryProductStatuses() {

    const endPoint = `${basePath}/constants?id=PRTSEARCH_STATUS&filter1Key=PRIORITY&filter1Value=900&filter1Operator=gt`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getOtherUseAmountUnits() {

    const endPoint = `${basePath}/constants?id=ALTERNATE_UNIT`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getEndUseCodes() {

    const endPoint = `${basePath}/constants?id=ENDUSE_CODE`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function postStatusChangeRequest(statusChangeRequest) {

    const endPoint = `${basePath}/status-changes`;

    const options = {
        body: JSON.stringify(statusChangeRequest),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getRegistration(regId) {

    const endPoint = `${basePath}/registrations/${encodeURIComponent(regId)}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function uploadFile(file, formData) {

    const endPoint = `${basePath}/files?className=${file.className}&classType=${file.classType}&objectKey=${file.objectKey}`;

    const options = {
        allowAutomaticContentType: true,
        body: formData,
        method: 'POST'
    };

    try {

        return await fetchService.fetch(endPoint, options);

    } catch (response) {

        return response;

    }

}

export async function deleteFile(file) {

    const endPoint = `${basePath}/files/${encodeURIComponent(file.fileName)}?serialNumber=${file.serialNumber}&className=${file.className}&classType=${file.classType}&objectKey=${file.objectKey}`;

    const options = {
        method: 'DELETE'
    };

    try {

        return await fetchService.fetch(endPoint, options);

    } catch (response) {

        return handleError(response);

    }

}

export async function deleteFileRga(file) {

    const endPoint = `${basePath}/files/${encodeURIComponent(file.fileName)}?serialNumber=${file.serialNumber}&className=${file.className}&classType=${file.classType}&objectKey=${file.objectKey}&requestedSource=RGA_DATA_MART`;

    const options = {
        method: 'DELETE'
    };

    try {

        return await fetchService.fetch(endPoint, options);

    } catch (response) {

        return handleError(response);

    }

}

export async function getFiles(file) {

    const endPoint = `${basePath}/files?objectKey=${file.objectKey}&className=${file.className}&classType=${file.classType}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getFilesRga(file, rga) {

    const endPoint = `${basePath}/rga/files?Rgano=${rga.rgaNumber}&PartNo=${rga.partNumber}&SapClmno=${rga.warrantyClaimNumber}&requestedSource=RGA_DATA_MART`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getMeasurementReadings(pin) {

    const endPoint = `${basePath}/products/${pin}/measurement-readings?isTcsm=false`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getPartDetails(partNumber) {

    const endPoint = `${basePath}/parts?partNumber=${encodeURIComponent(partNumber)}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function deleteComponent(pin, id, component) {

    const endPoint = `${basePath}/products/${pin}/components/${id}`;

    const options = {
        body: JSON.stringify(component),
        method: 'POST'
    };

    try {

        return await fetchService.fetch(endPoint, options);

    } catch (response) {

        return handleError(response);

    }

}

export async function postComponent(pin, component) {

    const endPoint = `${basePath}/products/${pin}/components`;

    const options = {
        body: JSON.stringify(component),
        method: 'POST'
    };

    try {

        return await fetchService.fetch(endPoint, options);

    } catch (response) {

        return handleError(response);

    }

}

export async function deleteOption(pin, id) {

    const endPoint = `${basePath}/products/${pin}/options/${id}`;

    const options = {
        method: 'DELETE'
    };

    try {

        return await fetchService.fetch(endPoint, options);

    } catch (response) {

        return handleError(response);

    }

}

export async function postOption(pin, option) {

    const endPoint = `${basePath}/products/${pin}/options`;

    const options = {
        body: JSON.stringify(option),
        method: 'POST'
    };

    try {

        return await fetchService.fetch(endPoint, options);

    } catch (response) {

        return handleError(response);

    }

}

export async function getExternalNotes(pin) {

    const endPoint = `${basePath}/products/${pin}/external-notes`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getFilteredEndUseCodes(filter1, filter2, filter3) {

    const {filter1Key, filter1Operator, filter1Value} = {...filter1};
    const {filter2Key, filter2Operator, filter2Value} = {...filter2};
    const {filter3Key, filter3Operator, filter3Value} = {...filter3};

    const endPoint = `${basePath}/constants?id=ENDUSE_CODE&filter1Key=${filter1Key}&filter1Operator=${filter1Operator}&filter1Value=${filter1Value}&filter2Key=${filter2Key}&filter2Operator=${filter2Operator}&filter2Value=${filter2Value}&filter3Key=${filter3Key}&filter3Operator=${filter3Operator}&filter3Value=${filter3Value}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getDealerRecommendation(dealerRecommendationPayload) {

    const endPoint = dealerRecommendationPayload.export === 'EXCEL' ?
        `${basePath}/pin/transfers-recommendations/collection?export=EXCEL` :
        `${basePath}/pin/transfers-recommendations/collection`;

    const options = {
        body: JSON.stringify(dealerRecommendationPayload),
        cloudPreferred: true,
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return dealerRecommendationPayload.export === 'EXCEL' ?
            response :
            response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getDealerRecommendationCount(dealerRecommendationPayload) {

    const endPoint = `${basePath}/pin/transfers-recommendations/collection?fetchCount=true`;

    const options = {
        body: JSON.stringify(dealerRecommendationPayload),
        cloudPreferred: true,
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function putDealerReviewTransfer(dealerReviewTransfer) {

    const endPoint = `${basePath}/pin/transfers-recommendations`;

    const fetchOptions = {
        body: JSON.stringify(dealerReviewTransfer),
        cloudPreferred: true,
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, fetchOptions);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getHighOnRentalDays(highOnRentalDaysPayload) {

    const endPoint = highOnRentalDaysPayload.export === 'EXCEL' ?
        `${basePath}/reports/highrentaldays?export=EXCEL` :
        `${basePath}/reports/highrentaldays`;

    const fetchOptions = {
        body: JSON.stringify(highOnRentalDaysPayload),
        cloudPreferred: true,
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, fetchOptions);

        return highOnRentalDaysPayload.export === 'EXCEL' ?
            response :
            response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getValidPinDetails(pin, suppressErrors = false) {

    const endPoint = `${basePath}/products/validatePin/${pin}`;

    const options = {
        cloudPreferred: true
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return suppressErrors ? response.json() : handleError(response);

    }

}

export async function createDuplicatePinPlate(duplicatePinPlate) {

    const endPoint = `${basePath}/products/pin/plate`;

    const options = {
        body: JSON.stringify(duplicatePinPlate),
        cloudPreferred: true,
        method: 'POST'
    };

    try {

        return await fetchService.fetch(endPoint, options);

    } catch (response) {

        return handleError(response);

    }

}

export async function deleteFileFromCloud(file) {

    const endPoint = `${basePath}/products/pin/plate/files/${encodeURIComponent(file.fileName)}?serialNumber=${file.serialNumber}&className=${file.className}&classType=${file.classType}&objectKey=${file.objectKey}`;

    const options = {
        cloudPreferred: true,
        method: 'DELETE'
    };

    try {

        return await fetchService.fetch(endPoint, options);

    } catch (response) {

        return handleError(response);

    }

}

export async function getPinPlateRecord(plateId) {

    const endPoint = `${basePath}/products/report/pin/plate/${encodeURIComponent(plateId)}`;

    const mockResponse = '';

    const options = {
        cloudPreferred: true
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        if (response.status === 204) {

            return mockResponse;

        }

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function putDuplicatePinPlateRequest(duplicatePinPlate) {

    const endPoint = duplicatePinPlate.status === 'INPROCESS' ? `${basePath}/products/pin/duplicate/orders` : `${basePath}/products/report/pin/plate/`;

    const fetchOptions = {
        body: JSON.stringify(duplicatePinPlate),
        cloudPreferred: true,
        method: 'PUT'
    };

    try {

        return await fetchService.fetch(endPoint, fetchOptions);

    } catch (error) {

        return handleError(error);

    }

}

export async function putFactoyDuplicatePinPlateRequest(duplicatePinPlate) {

    const endPoint = `${basePath}/products/report/pin/plate/`;

    const fetchOptions = {
        body: JSON.stringify(duplicatePinPlate),
        cloudPreferred: true,
        method: 'PUT'
    };

    try {

        return await fetchService.fetch(endPoint, fetchOptions);

    } catch (error) {

        return handleError(error);

    }

}

export async function getFactoryDuplicatePinPlateResults(factoryStatus) {

    const statusParam = Array.isArray(factoryStatus) ? factoryStatus.join(',') : factoryStatus;
    const endPoint = `${basePath}/products/pin/duplicate/orders?status=${statusParam}`;

    const options = {
        cloudPreferred: true
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function transferAllDealerRecom(transferAllDealerRecomm) {

    const endPoint = `${basePath}/pin/transfers-recommendations/accounts`;

    const fetchOptions = {
        body: JSON.stringify(transferAllDealerRecomm),
        cloudPreferred: true,
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, fetchOptions);

        return response;

    } catch (error) {

        return handleError(error);

    }

}

export async function getRecommendationBySearchType(dealerRecommendationFilterPayload) {

    const endPoint = `${basePath}/pin/transfers-recommendations/search`;

    const options = {
        body: JSON.stringify(dealerRecommendationFilterPayload),
        cloudPreferred: true,
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function processFactoryDuplicatePinPlates(pinPlateIds) {

    const endPoint = `${basePath}/products/pin/plate/process`;

    const payload = {
        requestIds: pinPlateIds,
        status: 'INPROCESS'
    };

    const options = {
        body: JSON.stringify(payload),
        cloudPreferred: true,
        method: 'PUT'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}



// WEBPACK FOOTER //
// ./src/product/shared/repositories/index.js